import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { EmailLoginComponent } from './login-layout/email-login/email-login.component';
import { PhoneLoginComponent } from './login-layout/phone-login/phone-login.component';
import {
  redirectLoggedInTo,
  AngularFireAuthGuard
} from '@angular/fire/auth-guard';
import { SignUpComponent } from './sign-up/sign-up.component';
import { EmailSignupComponent } from './sign-up/email-signup/email-signup.component';
import { PhoneSignupComponent } from './sign-up/phone-signup/phone-signup.component';

const redirectLoggedInToHome = () => redirectLoggedInTo(['']);

const routes: Routes = [
  {
    path: 'login',
    component: LoginLayoutComponent,
    pathMatch: 'full',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'login/email',
    component: EmailLoginComponent,
    pathMatch: 'full',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'login/phone',
    component: PhoneLoginComponent,
    pathMatch: 'full',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'signup/email',
    component: EmailSignupComponent,
    pathMatch: 'full',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'signup/phone',
    component: PhoneSignupComponent,
    pathMatch: 'full',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome }
  },
  {
    path: 'signup',
    component: SignUpComponent,
    pathMatch: 'full',
    data: { authGuardPipe: redirectLoggedInToHome }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class SecurityRoutingModule {}
